import React from "react";
import type { CellColor } from "../types.ts";
import { useCanvas } from "../hooks/use-canvas.ts";
import { drawTarget } from "../canvas/target-renderer.ts";

interface TargetPreviewProps {
  target: CellColor[][];
}

export function TargetPreview({ target }: TargetPreviewProps) {
  const canvasRef = useCanvas(
    (ctx, width, height) => {
      drawTarget(ctx, target, width, height);
    },
    [target]
  );

  return (
    <div className="flex flex-col items-center gap-2">
      <span className="text-sm font-medium text-slate-400 uppercase tracking-wider">
        Target
      </span>
      <canvas
        ref={canvasRef}
        className="w-56 h-56 rounded-lg border border-slate-700"
      />
    </div>
  );
}
